import ChallengeTypeEditModal from './ChallengeTypeEditModal';

export default ChallengeTypeEditModal;
